import { Injectable } from '@angular/core';
import { StorageService } from '@cm/core/storage';

/**
 *
 * @deprecated Use @cm/core/storage StorageService
 */
@Injectable({
	providedIn: 'root',
})
export class AtsStoreService {
	constructor(private readonly storage: StorageService) {}

	/**
	 *
	 * @deprecated Use @cm/core/storage StorageService.get
	 */
	public getFromStore<T = any>(name: string): T {
		return this.storage.get<T>(name);
	}

	/**
	 *
	 * @deprecated Use @cm/core/storage StorageService.delete
	 */
	public deleteFromStore(name) {
		this.storage.delete(name);
	}

	/**
	 *
	 * @deprecated Use @cm/core/storage StorageService.save
	 */
	public saveToStore(name: string, value: string, expiresIn: number = 90) {
		this.storage.save(name, value, expiresIn);
	}
}
